import { TextModalCombinedProps } from './types';

const usePresenter = (props: TextModalCombinedProps): TextModalCombinedProps => {
  return props;
};

export default usePresenter;
